<form class="form-horizontal" role="form">
  <hs-common-url [type]="fileType" [(url)]="data.url" (connect)="connect()">
  </hs-common-url>

  <div *ngIf="data.showDetails">
    <hs-new-layer-form [data]="data"></hs-new-layer-form>

    <hs-add-to-map [disabled]="!data.title" (add)="add()" class="w-100 mt-2"></hs-add-to-map>
  </div>

</form>
